'use strict';

/**
 * 环形进度条组件
 */
var React = require('react');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var versionHelper = require('../../helper/versionHelper');

var CircleProgressBar = React.createClass({

  componentDidUpdate: function () {
    this.rePaint();
  },

  componentDidMount: function () {
    this.rePaint();
  },

  componentWillUnmount: function () {
    if (this.requestID) {
      cancelAnimationFrame(this.requestID);
    }
  },

  rePaint: function () {
    var value;
    var tw;
    var x;
    var textSize;
    var y;
    var w;
    var h;
    var thickness;
    var trackColor;
    var indicatorColor;
    var value;

    var self = this;

    this.requestID = window.requestAnimationFrame(function () {
      var canvas = ReactDOM.findDOMNode(self.refs.canvas);
      if (!canvas) {
        return;
      }
      w = styleHelper.getWidth(self.props);
      h = styleHelper.getHeight(self.props);
      thickness = styleHelper.getInt(self.props, propConst.THICKNESS);
      trackColor = styleHelper.getPropertyValue(self.props, propConst.TRACK_COLOR);
      indicatorColor = styleHelper.getPropertyValue(self.props, propConst.INDICATOR_COLOR);
      value = styleHelper.getInt(self.props, propConst.PROGRESS) || styleHelper.getInt(self.props, propConst.VALUE);
      var ctx = canvas.getContext('2d');
      var cx = w / 2;
      var cy = h / 2;
      var r = (w - thickness) / 2;
      ctx.clearRect(0, 0, w, h);
      ctx.beginPath();
      ctx.arc(cx, cy, r, 0, Math.PI * 2);
      ctx.closePath();
      ctx.strokeStyle = trackColor;
      ctx.lineCap = 'round';
      ctx.lineWidth = thickness;
      ctx.stroke();
      ctx.beginPath();
      ctx.strokeStyle = indicatorColor;
      ctx.lineWidth = thickness;
      ctx.lineCap = 'round';
      ctx.arc(cx, cy, r, 0 - Math.PI / 2, Math.PI * (value / 100 * 2 - 0.5));
      ctx.stroke();
    });
  },
  render: function () {
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var value = styleHelper.getInt(this.props, propConst.PROGRESS) || styleHelper.getInt(this.props, propConst.VALUE);
    var textStyle = {
      width: '100%',
      height: '100%',
      textAlign: 'center',
      lineHeight: h + 'px',
      whiteSpace: 'nowrap'
    };
    styleHelper.builderTextStyle(this.props, textStyle);
    if (versionHelper.isPageVersionLowerThan4_3()) {
      textStyle.fontSize = Math.round(w * 0.215);
    } else {
      textStyle.fontSize = parseInt(this.props.textSize, 10);
    }
    return (<div style={textStyle}>
      <canvas ref="canvas"
              style={{
                left: 0,
                top: 0,
                width: w,
                height: h,
                position: 'absolute'
              }}
              width={w}
              height={h}/>
      <label>
        {value + '%'}
      </label>
    </div>);
  }
});

module.exports = CircleProgressBar;


// WEBPACK FOOTER //
// ./src/views/Components/CircleProgressBar.jsx